import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {CommissionContractSettlement} from "../interface/commission-contract-settlement";
import {CommissionUpdatePackage} from "../interface/commission-update-package";

@Injectable({
  providedIn: 'root'
})
export class CommissionUpdatePackageService {
  public readonly CommissionUpdatePackageListSubject: ReplaySubject<CountedAndPaginated<CommissionUpdatePackage>>
    = new ReplaySubject<CountedAndPaginated<CommissionUpdatePackage>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/commission-update-package`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/commission-update-package/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;
    }

  }

  public loadList(page: number, pageSize: number, filters: object, sort?: { sortBy?: string, sortOrder?: string }): void {
    const sortBy = sort?.sortBy || 'createdAt';
    const sortOrder = sort?.sortOrder || 'DESC';

    this.httpClient.get(`/rest/crm/commission-update-package?page=${page + 1}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<CommissionUpdatePackage>) => {
          this.CommissionUpdatePackageListSubject.next(result);
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-update-package/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public get(commissionSettlementId: string): Observable<CommissionUpdatePackage> {
    return this.httpClient.get(`/rest/crm/commission-update-package/${commissionSettlementId}`)
      .pipe(first()) as Observable<CommissionUpdatePackage>;
  }

  public findCommissionUpdatePackage(filters: object): Observable<any> {
    return this.httpClient.get(`/rest/crm/commission-update-package?` + this.filterService.parseFilters(filters))
      .pipe(first());
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/commission-update-package/${uuid}`)
      .pipe(first());
  }
}
